import { render, staticRenderFns } from "./OperaGoodsOrderDetail.vue?vue&type=template&id=b3c67730&scoped=true&"
import script from "./OperaGoodsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsOrderDetail.vue?vue&type=style&index=0&id=b3c67730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c67730",
  null
  
)

export default component.exports